import { useGlobalMerchant } from './useGlobalMerchant';
import { useMerchantQuery } from '~/queries/useMerchantQuery';
import { usePublicProgrammeQuery } from '~/queries/usePublicProgrammeQuery';

export const useDefaultProgramme = () => {
	const publicMerchant = useGlobalMerchant();

	const merchantId = computed(() => publicMerchant.value?.id);

	const { data: merchant, isLoading: isLoadingMerchant } = useMerchantQuery({ merchantId });

	const { data: programme, isLoading: isLoadingProgramme } = usePublicProgrammeQuery({ merchantId, programmeId: computed(() => merchant.value?.defaultProgrammeId ?? undefined) });

	const isLoading = computed(() => isLoadingMerchant.value && isLoadingProgramme.value);

	return {
		programme,
		isLoading,
	};
};
